import script from "./CourseChats.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseChats.vue?vue&type=script&lang=ts&setup=true"

import "./CourseChats.vue?vue&type=style&index=0&id=6ab1d55f&scoped=true&lang=css"
/* custom blocks */
import block0 from "./CourseChats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab1d55f"]])

export default __exports__